"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.H3 = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.H3 = (0, styled_components_1.default)('h3') `
  color: var(--Text, #333);
  font-family: Inter, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  width: 100%;
  margin: 10px 0
`;
